export const industriesData = {
   retail: {
    id: "retail",
    title: "Retail & E-Commerce",
    heroImg: "/assets/what/item3.png",
    overviewImg: "/assets/what/img3.png",
    overviewTitle: "Elevating Digital Retail",
    overviewText:
        "In today’s digital-first retail world, customers expect smooth, connected experiences at every step. At Mobikode, we build scalable e-commerce platforms, omni-channel solutions, and intelligent supply chain systems that make operations easier and help businesses grow sales in a practical, sustainable way.",
    solutions: [
        {
            id: "ret-1",
            title: "Online Marketplaces",
            category: "solution",
            desc: "We build scalable, multi-vendor e-commerce platforms that handle complex catalogs and high traffic with ease. At Mobikode, we add secure payments and smart recommendations to create smoother shopping experiences and better conversions.",
            defaultBg: "bg-gradient-to-b from-[#ED6800] to-[#FF8C00]",
            link: "/online-marketplaces"
        },
        {
            id: "ret-2",
            title: "Omni-channel Retail",
            category: "solution",
            desc: "Bring your physical and online stores together with seamless omnichannel solutions. Keep inventory, pricing, and customer data in sync, so you can offer a smooth, consistent experience to your customers everywhere.",
            defaultBg: "bg-gradient-to-r from-[#ED6800] to-[#E65C00]",
            link: "/omni-channel"
        },
        {
            id: "ret-3",
            title: "Point of Sale (POS) Systems",
            category: "solution",
            desc: "Upgrade your checkout experience with cloud-based POS software that works seamlessly with your back-office systems. Speed up billing, track inventory in real time, and stay operational even offline, so your store runs smoothly and your customers always enjoy a hassle-free experience.",
            defaultBg: "bg-gradient-to-br from-[#ED6800] to-[#CC5200]",
            link: "/pos-systems"
        },
        {
            id: "ret-4",
            title: "Customer Experience Platforms",
            category: "solution",
            desc: "Build genuine brand loyalty by creating personalized marketing and meaningful user journeys. With smooth CRM integrations and AI-powered chatbots, every interaction feels natural, timely, and relevant, helping you connect with your customers in a more human way and build relationships that truly last.",
            defaultBg: "bg-gradient-to-bl from-[#ED6800] to-[#FF9933]",
            link: "/cx-platforms"
        },
        {
            id: "ret-5",
            title: "Inventory Management",
            category: "solution",
            desc: "Avoid running out of stock or overstocking with simple, real-time inventory tracking. With smart insights and automated reordering, you can keep the right balance, reduce waste, and ensure your supply chain runs smoothly and efficiently.",
            defaultBg: "bg-gradient-to-tr from-[#ED6800] to-[#B34700]",
            link: "/inventory-management"
        },
        {
            id: "ret-6",
            title: "Supply Chain Platforms",
            category: "solution",
            desc: "Get clear, end-to-end visibility of your retail supply chain, from manufacturer to customer. Our platform makes logistics simpler, improves warehouse efficiency, and gives you useful insights to deliver faster, cut costs, and run your operations more smoothly.",
            defaultBg: "bg-gradient-to-t from-[#ED6800] to-[#993D00]",
            link: "/supply-chain"
        },
    ]
},
    healthcare: {
    id: "healthcare",
    title: "Healthcare & Life Sciences",
    heroImg: "/assets/what/item2.png",
    overviewImg: "/assets/what/img2.png",
    overviewTitle: "Digitalizing Patient Care",
    overviewText: "Healthcare is changing fast, and we help you keep up with secure, scalable solutions that improve patient care and simplify everyday clinical workflows.",
    solutions: [
        {
            id: "hc-1",
            title: "Hospitals & Healthcare Providers",
            category: "solution",
            desc: "Simplify hospital operations with one connected system for patient data, scheduling, and billing. Help your staff spend less time on admin work and more time caring for patients.",
            defaultBg: "bg-gradient-to-b from-[#00A859] to-[#007A3E]",
            link: "/hospital-management"
        },
        {
            id: "hc-2",
            title: "HealthTech Platforms",
            category: "solution",
            desc: "Make healthcare more accessible with secure, easy-to-use telemedicine and remote monitoring solutions. We create HIPAA-compliant platforms that connect patients and doctors instantly, enabling continuous care, better outcomes, and a more personal healthcare experience.",
            defaultBg: "bg-gradient-to-r from-[#00A859] to-[#00994C]",
            link: "/healthtech"
        },
        {
            id: "hc-3",
            title: "Pharmaceutical Companies",
            category: "solution",
            desc: "Make the drug lifecycle simpler and more reliable with smart, easy-to-use software. We help improve transparency, manage compliance, reduce counterfeiting, and ensure life-saving medicines reach patients safely and on time.",
            defaultBg: "bg-gradient-to-br from-[#00A859] to-[#006633]",
            link: "/pharma"
        },
        {
            id: "hc-4",
            title: "Medical Devices",
            category: "solution",
            desc: "Improve patient care with smart, IoT-enabled medical devices. At Mobikode, we create secure, reliable solutions that share real-time health data with doctors, helping them make faster, more informed decisions.",
            defaultBg: "bg-gradient-to-bl from-[#00A859] to-[#33CC77]",
            link: "/medical-devices"
        },
        {
            id: "hc-5",
            title: "Clinical Research",
            category: "solution",
            desc: "Accelerate medical breakthroughs with secure, scalable platforms designed for clinical trials. We help keep data reliable, make patient onboarding smoother, and give researchers clear insights, so they can focus on discoveries and make confident decisions faster.",
            defaultBg: "bg-gradient-to-tr from-[#00A859] to-[#004D26]",
            link: "/clinical-research"
        },
        {
            id: "hc-6",
            title: "Health Insurance Platforms",
            category: "solution",
            desc: "Modernize your insurance journey with simple, smart digital solutions. Automate claims, improve risk assessment, and create easy-to-use policyholder experiences. Move away from outdated systems and embrace agile platforms that save time, boost efficiency, and keep your customers happier.",
            defaultBg: "bg-gradient-to-t from-[#00A859] to-[#00592D]",
            link: "/health-insurance"
        },
    ]
},
  energy: {
    id: "energy",
    title: "Energy, Oil & Gas",
    heroImg: "/assets/what/item5.png",
    overviewImg: "/assets/what/item16.png",
    overviewTitle: "Fueling Digital Energy Solutions",
    overviewText: "Improve energy production and distribution with smart technology, automation, and data insights, helping energy and oil businesses run smoothly and grow efficiently.",
    solutions: [
        {
            id: "nrg-1",
            title: "Oil Exploration",
            category: "solution",
            desc: "Improve drilling accuracy and reduce risks with smart geospatial insights and 3D mapping. We help geologists and engineers understand seismic data faster, so they can make better decisions and run more efficient, successful exploration projects.",
            defaultBg: "bg-gradient-to-b from-[#D35400] to-[#E67E22]",
            link: "/oil-exploration"
        },
        {
            id: "nrg-2",
            title: "Refineries",
            category: "solution",
            desc: "Boost refinery performance while keeping your workplace safe with smart, easy-to-use automation. We help you monitor equipment health and optimize operations in real time, reducing downtime, minimizing risks, and ensuring everything runs smoothly and efficiently every day.",
            defaultBg: "bg-gradient-to-r from-[#D35400] to-[#A04000]",
            link: "/refineries"
        },
        {
            id: "nrg-3",
            title: "Petrochemicals",
            category: "solution",
            desc: "Simplify hazardous material handling with smart tracking systems that give you clear visibility across your supply chain. Stay compliant with environmental regulations while keeping your operations safe, efficient, and easy to manage.",
            defaultBg: "bg-gradient-to-br from-[#D35400] to-[#873600]",
            link: "/petrochemicals"
        },
        {
            id: "nrg-4",
            title: "Power Generation",
            category: "solution",
            desc: "Maintain reliable energy output with intelligent operations software for nuclear, thermal, and hydro plants. Gain real-time visibility, enable predictive maintenance, and improve efficiency across critical systems for consistent, optimized performance.",
            defaultBg: "bg-gradient-to-bl from-[#D35400] to-[#BA4A00]",
            link: "/power-generation"
        },
        {
            id: "nrg-5",
            title: "Renewable Energy",
            category: "solution",
            desc: "At Mobikode, we make the green transition simpler by helping you monitor solar and wind systems in one place. With AI, we improve energy output, predict performance, and ensure smooth integration into the grid.",
            defaultBg: "bg-gradient-to-tr from-[#27AE60] to-[#2ECC71]",
            link: "/renewable-energy"
        },
        {
            id: "nrg-6",
            title: "Smart Grid Technology",
            category: "solution",
            desc: "Upgrade your energy systems with IoT-powered smart grids that keep supply and demand in balance and spot outages instantly. Our solutions create smooth two-way communication between utilities and consumers, making energy use smarter, more reliable, and sustainable.",
            defaultBg: "bg-gradient-to-t from-[#D35400] to-[#935116]",
            link: "/smart-grid"
        },
    ]
},
   telecom: {
    id: "telecom",
    title: "Telecommunications",
    heroImg: "/assets/what/item6.png",
    overviewImg: "/assets/what/item15.png",
    overviewTitle: "Connecting the World Faster",
    overviewText: "Telecom providers need reliable, scalable systems. We build BSS/OSS solutions and 5G platforms that keep networks running smoothly and people connected.",
    solutions: [
        {
            id: "tel-1",
            title: "Telecom Operators",
            category: "solution",
            desc: "Modernize your legacy systems with intuitive CRM, automated billing, and faster service provisioning. Our solutions make it easy to manage millions of users, reduce churn, and grow your revenue with confidence.",
            defaultBg: "bg-gradient-to-b from-[#141E30] to-[#243B55]",
            link: "/telecom-operators"
        },
        {
            id: "tel-2",
            title: "Network Infrastructure Providers",
            category: "solution",
            desc: "Improve fiber routing and tower maintenance with smart GIS and traffic tools. Track operations in real time, simplify field work, and keep your network running smoothly with minimal downtime and better efficiency.",
            defaultBg: "bg-gradient-to-r from-[#141E30] to-[#4B6CB7]",
            link: "/network-infrastructure"
        },
        {
            id: "tel-3",
            title: "5G Technology Platforms",
            category: "solution",
            desc: "Experience the true power of 5G with solutions built for speed and reliability. We design smart edge computing and network tools that help your IoT systems grow smoothly and efficiently.",
            defaultBg: "bg-gradient-to-br from-[#141E30] to-[#3A6073]",
            link: "/5g-platforms"
        },
        {
            id: "tel-4",
            title: "Communication Platforms",
            category: "solution",
            desc: "Help your business stay connected with simple, secure communication tools. From calls and video meetings to automated messages, we create reliable systems that make global communication smooth, clear, and effortless.",
            defaultBg: "bg-gradient-to-bl from-[#141E30] to-[#16222A]",
            link: "/communication-platforms"
        },
    ]
},
   media: {
    id: "media",
    title: "Media & Entertainment",
    heroImg: "/assets/what/item7.png",
    overviewImg: "/assets/what/item14.png",
    overviewTitle: "Revolutionizing Digital Content",
    overviewText: "We create simple, powerful streaming and gaming solutions that help creators share smooth, engaging experiences with people anywhere in the world.",
    solutions: [
        {
            id: "med-1",
            title: "Streaming Platforms",
            category: "solution",
            desc: "We create easy-to-use OTT platforms for live shows and on-demand videos that run smoothly without interruptions. With smart streaming and strong protection, your content stays safe while your audience enjoys a seamless viewing experience on any device.",
            defaultBg: "bg-gradient-to-b from-[#8E2DE2] to-[#4A00E0]",
            link: "/streaming"
        },
        {
            id: "med-2",
            title: "Digital Media Platforms",
            category: "solution",
            desc: "We help editorial teams publish content more easily with flexible headless CMS solutions. It keeps workflows simple, improves SEO naturally, and helps deliver rich, engaging content that truly connects with readers around the world.",
            defaultBg: "bg-gradient-to-r from-[#8E2DE2] to-[#654EA3]",
            link: "/digital-media"
        },
        {
            id: "med-3",
            title: "Gaming Companies",
            category: "solution",
            desc: "We help create smooth and exciting multiplayer gaming experiences with fast, reliable backend systems that work in real time. Our solutions make it easier to match players fairly, track performance, and build smart monetization systems that support growth. Everything is designed to keep players engaged and games running seamlessly across mobile and console platforms.",
            defaultBg: "bg-gradient-to-br from-[#8E2DE2] to-[#B06AB3]",
            link: "/gaming"
        },
        {
            id: "med-4",
            title: "Advertising Technology (AdTech)",
            category: "solution",
            desc: "We help businesses get more value from their ads by reaching the right people at the right time. Using smart programmatic advertising, real-time bidding, and data insights, we make campaigns more personal, effective, and focused on real results that grow revenue.",
            defaultBg: "bg-gradient-to-bl from-[#8E2DE2] to-[#512DA8]",
            link: "/adtech"
        },
        {
            id: "med-5",
            title: "Content Distribution Platforms",
            category: "solution",
            desc: "Make your content reach people anywhere in the world without delays. We set up smart CDN solutions that keep things fast, handle heavy traffic easily, and give users a smooth, reliable experience every time.",
            defaultBg: "bg-gradient-to-tr from-[#8E2DE2] to-[#3F2B96]",
            link: "/content-distribution"
        },
    ]
},
   logistics: {
    id: "logistics",
    title: "Transportation & Logistics",
    heroImg: "/assets/what/item8.png",
    overviewImg: "/assets/what/item13.png",
    overviewTitle: "Optimizing Global Supply Chains",
    overviewText: "We build simple, smart logistics systems that help you track fleets, plan routes, and manage freight better saving costs and making sure deliveries always reach on time, no matter where they are going.",
    solutions: [
        {
            id: "log-1",
            title: "Logistics Management",
            category: "solution",
            desc: "Make your supply chain simpler and easier to manage with our end-to-end platform built for 3PL providers and distributors. Automate daily operations, improve warehouse efficiency, and track inventory in real time so everything runs smoothly and on time.",
            defaultBg: "bg-gradient-to-b from-[#3E5151] to-[#DECBA4]",
            link: "/logistics-management"
        },
        {
            id: "log-2",
            title: "Shipping & Maritime",
            category: "solution",
            desc: "Make ocean freight simpler and more reliable with digital tools that connect ports, track vessels in real time, and automate customs paperwork. We help reduce delays, speed up operations, and keep everything running smoothly across the entire shipping journey.",
            defaultBg: "bg-gradient-to-r from-[#3E5151] to-[#5C258D]",
            link: "/shipping-maritime"
        },
        {
            id: "log-3",
            title: "Freight Platforms",
            category: "solution",
            desc: "We make it easier for shippers and carriers to connect and move freight without hassle. With smart load matching, simple pricing, and better route planning, we help reduce empty trips and keep deliveries running smoothly.",
            defaultBg: "bg-gradient-to-br from-[#3E5151] to-[#43C6AC]",
            link: "/freight-platforms"
        },
        {
            id: "log-4",
            title: "Fleet Management Systems",
            category: "solution",
            desc: "Keep your commercial fleet running smoothly with real-time GPS tracking, fuel monitoring, and smart maintenance alerts. We help you improve driver safety, cut unnecessary costs, and make better use of every vehicle through simple, clear dashboards you can trust.",
            defaultBg: "bg-gradient-to-bl from-[#3E5151] to-[#191654]",
            link: "/fleet-management"
        },
        {
            id: "log-5",
            title: "Smart Mobility Platforms",
            category: "solution",
            desc: "We help make city travel simpler and smarter with easy-to-use apps for ride-sharing, bikes, and public transport. Along with that, we build strong admin systems to manage pricing, vehicles, and daily operations smoothly.",
            defaultBg: "bg-gradient-to-tr from-[#3E5151] to-[#203A43]",
            link: "/smart-mobility"
        },
    ]
},
    travel: {
    id: "travel",
    title: "Travel & Hospitality",
    heroImg: "/assets/what/item9.png",
    overviewImg: "/assets/what/item12.png",
    overviewTitle: "Seamless Travel Experiences",
    overviewText: "Help travel and hospitality businesses run smoothly with easy booking systems, property tools, and personalized itineraries that make every guest experience better and more memorable.",
    solutions: [
        {
            id: "trv-1",
            title: "Airlines",
            category: "solution",
            desc: "We help make air travel smoother for everyone. From easy ticket booking and hassle-free check-in to rewarding loyalty programs, we improve the passenger journey. We also support airlines with smart tools for crew scheduling and faster aircraft turnaround, helping operations run more efficiently and reliably.",
            defaultBg: "bg-gradient-to-b from-[#00C9FF] to-[#92FE9D]",
            link: "/airlines"
        },
        {
            id: "trv-2",
            title: "Hotels & Resorts",
            category: "solution",
            desc: "Upgrade your property with easy-to-use cloud PMS that takes care of bookings, housekeeping, and billing. Make guests happier with smooth contactless check-ins and personalized service that feels more welcoming and simple.",
            defaultBg: "bg-gradient-to-r from-[#00C9FF] to-[#009FFF]",
            link: "/hotels-resorts"
        },
        {
            id: "trv-3",
            title: "Online Travel Agencies",
            category: "solution",
            desc: "We create simple and fast travel booking systems that bring flights, hotels, and car rentals together in one place. Everything is easy to search, safe to pay for, and smooth to manage, making travel planning stress-free for users.",
            defaultBg: "bg-gradient-to-br from-[#00C9FF] to-[#0072FF]",
            link: "/ota"
        },
        {
            id: "trv-4",
            title: "Tourism Platforms",
            category: "solution",
            desc: "We help travel destinations tell their story in a more engaging way through simple digital guides and easy booking systems. Our platforms bring local tour operators and global travellers together, making it effortless to explore, connect, and plan memorable trips.",
            defaultBg: "bg-gradient-to-bl from-[#00C9FF] to-[#00B4DB]",
            link: "/tourism-platforms"
        },
        {
            id: "trv-5",
            title: "Reservation Systems",
            category: "solution",
            desc: "Help your business earn more with simple, custom booking software that keeps everything organized. See real-time availability, set smart pricing, avoid double bookings, and manage all your channels from one easy dashboard. It’s built to save time and make daily operations smooth and stress-free.",
            defaultBg: "bg-gradient-to-tr from-[#00C9FF] to-[#0083B0]",
            link: "/reservation-systems"
        },
    ]
},
   government: {
    id: "government",
    title: "Government & Public Sector",
    heroImg: "/assets/what/item10.png",
    overviewImg: "/assets/what/item11.png",
    overviewTitle: "Digitizing Public Services",
    overviewText: "We help governments create simple, secure, and transparent digital services that improve everyday life. From smart city systems to e-governance platforms, our focus is always on making services easier, faster, and truly citizen-friendly.",
    solutions: [
        {
            id: "gov-1",
            title: "Smart Cities",
            category: "solution",
            desc: "We help cities become smarter with IoT solutions that improve daily life, better traffic flow, efficient streetlights, and smoother public services, making urban spaces safer, cleaner, and more connected for everyone.",
            defaultBg: "bg-gradient-to-b from-[#1F1C2C] to-[#928DAB]",
            link: "/smart-cities"
        },
        {
            id: "gov-2",
            title: "Digital Governance Platforms",
            category: "solution",
            desc: "Make administration simpler and more transparent with secure digital portals. We help automate document handling, manage policies easily, and improve compliance, so teams can work faster, smoother, and without unnecessary delays.",
            defaultBg: "bg-gradient-to-r from-[#1F1C2C] to-[#434343]",
            link: "/digital-governance"
        },
        {
            id: "gov-3",
            title: "Citizen Service Platforms",
            category: "solution",
            desc: "We help governments and citizens connect more easily through simple digital apps and portals. From paying taxes to renewing licenses or raising issues, we make public services smoother, faster, and more accessible for everyone.",
            defaultBg: "bg-gradient-to-br from-[#1F1C2C] to-[#5C258D]",
            link: "/citizen-services"
        },
        {
            id: "gov-4",
            title: "Defense & Security Systems",
            category: "solution",
            desc: "We create secure, highly encrypted communication and data systems for critical operations. Our focus is to help defense teams share information safely, reliably, and with complete trust when it matters most.",
            defaultBg: "bg-gradient-to-bl from-[#1F1C2C] to-[#3A3845]",
            link: "/defense-security"
        },
        {
            id: "gov-5",
            title: "Public Infrastructure Technology",
            category: "solution",
            desc: "Keep roads, bridges, and public transport safer with smart monitoring. We use real-time sensor data and simple predictive insights to spot problems early and help fix them before they turn serious.",
            defaultBg: "bg-gradient-to-tr from-[#1F1C2C] to-[#2C3E50]",
            link: "/public-infrastructure"
        },
    ]
},
   education: {
    id: "education",
    title: "Education (EdTech)",
    heroImg: "/assets/what/item11.png",
    overviewImg: "/assets/what/item10.png",
    overviewTitle: "Transforming the Future of Learning",
    overviewText: "We build simple, engaging e-learning platforms, smart campus tools, and virtual classrooms that make learning easier, more connected, and enjoyable for students and educators everywhere.",
    solutions: [
        {
            id: "edu-1",
            title: "Universities",
            category: "solution",
            desc: "Make campus life easier and more connected with a simple ERP system that handles admissions, fees, academics, and alumni needs, all in one place for students, teachers, and smooth daily operations.",
            defaultBg: "bg-gradient-to-b from-[#F2994A] to-[#F2C94C]",
            link: "/universities"
        },
        {
            id: "edu-2",
            title: "Schools",
            category: "solution",
            desc: "Make it easier for teachers and parents to stay connected with simple, modern student systems. Track attendance, assignments, and grades effortlessly while helping students learn in a more organized and supportive environment.",
            defaultBg: "bg-gradient-to-r from-[#F2994A] to-[#E29587]",
            link: "/schools"
        },
        {
            id: "edu-3",
            title: "Online Learning Platforms",
            category: "solution",
            desc: "Make education easier and more accessible for everyone with simple, reliable e-learning platforms. We build scalable systems with video lessons, live classes, and automated assessments that help millions of learners grow anytime, anywhere.",
            defaultBg: "bg-gradient-to-br from-[#F2994A] to-[#D66D75]",
            link: "/online-learning"
        },
        {
            id: "edu-4",
            title: "Learning Management Systems (LMS)",
            category: "solution",
            desc: "Support HR teams and educational institutions with simple, flexible learning platforms. Create courses easily, track learner progress, share engaging training, issue certificates, and clearly understand how well people are learning.",
            defaultBg: "bg-gradient-to-bl from-[#F2994A] to-[#C33764]",
            link: "/lms"
        },
    ]
},
   realEstate: {
    id: "real-estate",
    title: "Real Estate & Construction",
    heroImg: "/assets/what/item12.png",
    overviewImg: "/assets/what/item9.png",
    overviewTitle: "Innovating Property and Build Tech",
    overviewText: "We make construction and real estate easier to manage with simple, smart PropTech solutions, like virtual tours and project tools that help teams stay organized and sell properties more effectively.",
    solutions: [
        {
            id: "re-1",
            title: "Property Management Platforms",
            category: "solution",
            desc: "We make life easier for landlords and property managers by handling rent collection, lease tracking, and maintenance automatically. Tenants also get a simple, secure space to pay rent and stay connected.",
            defaultBg: "bg-gradient-to-b from-[#614385] to-[#516395]",
            link: "/property-management"
        },
        {
            id: "re-2",
            title: "PropTech Solutions",
            category: "solution",
            desc: "Make property buying and selling easier and more engaging with AR/VR tours and smart valuation tools. We help real estate agents stay organized, track leads, manage listings, and close deals smoothly with simple, effective CRM solutions.",
            defaultBg: "bg-gradient-to-r from-[#614385] to-[#453A94]",
            link: "/proptech"
        },
        {
            id: "re-3",
            title: "Construction Project Management",
            category: "solution",
            desc: "Keep your construction projects running smoothly without stress. Easily share blueprints, manage contractor bids, track on-site work, and handle materials from one simple dashboard, helping you save time, reduce delays, and stay within budget.",
            defaultBg: "bg-gradient-to-br from-[#614385] to-[#2B32B2]",
            link: "/construction-management"
        },
        {
            id: "re-4",
            title: "Smart Building Technology",
            category: "solution",
            desc: "We turn regular buildings into smart spaces using IoT. From lighting and climate control to security and energy savings, everything works automatically to make life easier, more comfortable, and eco-friendly.",
            defaultBg: "bg-gradient-to-bl from-[#614385] to-[#141E30]",
            link: "/smart-buildings"
        },
    ]
},
   agriculture: {
    id: "agriculture",
    title: "Agriculture & AgriTech",
    heroImg: "/assets/what/img2.png",
    overviewImg: "/assets/what/item8.png",
    overviewTitle: "Cultivating Smarter Farming",
    overviewText: "We use AI, IoT, and data to make farming easier and smarter. From understanding weather and improving crop yields to simplifying supply chains, we help farmers make better decisions and grow more with less effort.",
    solutions: [
        {
            id: "agri-1",
            title: "Precision Farming",
            category: "solution",
            desc: "We help farmers make better decisions using simple, smart tools like drones and soil sensors. This gives clear field insights to save water, reduce waste, and grow healthier, stronger crops.",
            defaultBg: "bg-gradient-to-b from-[#56AB2F] to-[#A8E063]",
            link: "/precision-farming"
        },
        {
            id: "agri-2",
            title: "Agricultural Supply Chain Platforms",
            category: "solution",
            desc: "Make food safer and more transparent with simple blockchain tracking. We help you follow every step of produce from the farm, through processing, right to the store shelf, so you always know its journey.",
            defaultBg: "bg-gradient-to-r from-[#56AB2F] to-[#4CAF50]",
            link: "/agri-supply-chain"
        },
        {
            id: "agri-3",
            title: "Agri Marketplaces",
            category: "solution",
            desc: "Help farmers earn better by connecting them directly with buyers through a simple, secure digital marketplace. We reduce middlemen, improve transparency, and make trading easier, fairer, and more rewarding for everyone involved.",
            defaultBg: "bg-gradient-to-br from-[#56AB2F] to-[#388E3C]",
            link: "/agri-marketplaces"
        },
        {
            id: "agri-4",
            title: "Farm Analytics",
            category: "solution",
            desc: "Help farmers and agribusinesses stay one step ahead with simple, smart predictions. We use data to forecast weather changes and pest risks early, so you can protect your crops, plan better seasons, and secure healthier, more reliable harvests.",
            defaultBg: "bg-gradient-to-bl from-[#56AB2F] to-[#2E7D32]",
            link: "/farm-analytics"
        },
    ]
},
   cpg: {
    id: "cpg",
    title: "Consumer Goods (CPG/FMCG)",
    heroImg: "/assets/what/item14.png",
    overviewImg: "/assets/what/item7.png",
    overviewTitle: "Accelerating Consumer Reach",
    overviewText: "We help FMCG brands grow by making distribution simpler, understanding customers better through real insights, and connecting smoothly with retail partners so products reach people faster and more effectively.",
    solutions: [
        {
            id: "cpg-1",
            title: "Food & Beverage Technology",
            category: "solution",
            desc: "Keep your food production safe and consistent with easy-to-use software for recipes, batch tracking, and quality checks. We help you stay compliant and confident, making sure every step meets safety standards.",
            defaultBg: "bg-gradient-to-b from-[#FF416C] to-[#FF4B2B]",
            link: "/fnb-tech"
        },
        {
            id: "cpg-2",
            title: "Household Products Platforms",
            category: "solution",
            desc: "We use AI to help you stay ahead of demand, so you never run out or overstock. Your products stay available when customers need them, and your operations run smoothly and efficiently.",
            defaultBg: "bg-gradient-to-r from-[#FF416C] to-[#E91E63]",
            link: "/household-products"
        },
        {
            id: "cpg-3",
            title: "Consumer Electronics Systems",
            category: "solution",
            desc: "Make life easier for your customers even after they buy from you. From simple warranty tracking and quick product registration to hassle-free returns, we help you manage everything smoothly. We also connect smart home apps so users can control their devices without stress, all in one place.",
            defaultBg: "bg-gradient-to-br from-[#FF416C] to-[#C2185B]",
            link: "/consumer-electronics"
        },
        {
            id: "cpg-4",
            title: "Brand Distribution Platforms",
            category: "solution",
            desc: "Make your B2B supply chain easier to manage with a simple, centralized system for distributors and automated ordering. See real-time sales data, understand what’s working, and improve how you plan marketing and distribution. It helps you work smarter, reduce manual effort, and make better decisions faster.",
            defaultBg: "bg-gradient-to-bl from-[#FF416C] to-[#880E4F]",
            link: "/brand-distribution"
        },
    ]
},
   professionalServices: {
    id: "professional-services",
    title: "Professional Services",
    heroImg: "/assets/what/item15.png",
    overviewImg: "/assets/what/item6.png",
    overviewTitle: "Software for Service Experts",
    overviewText: "Help law firms, consulting agencies, and HR teams stay organized with simple, secure tools for managing documents, tracking talent, and handling everyday work more smoothly.",
    solutions: [
        {
            id: "ps-1",
            title: "Consulting Firms",
            category: "solution",
            desc: "Help your agency run smoother and more profitably with simple, smart ERP tools. Easily track time, manage your team’s work, and understand project performance in real time. Keep all client communication and deliverables in one secure place so nothing gets missed. It’s everything you need to stay organized, efficient, and in control of your projects.",
            defaultBg: "bg-gradient-to-b from-[#373B44] to-[#4286f4]",
            link: "/consulting"
        },
        {
            id: "ps-2",
            title: "Legal Technology Platforms",
            category: "solution",
            desc: "Keep your clients’ data safe while making legal work easier. We help law firms manage cases, automate document discovery, handle contracts, and track deadlines smoothly so they can focus more on winning cases and less on manual work.",
            defaultBg: "bg-gradient-to-r from-[#373B44] to-[#1E3C72]",
            link: "/legal-tech"
        },
        {
            id: "ps-3",
            title: "Accounting Systems",
            category: "solution",
            desc: "Make finance easier for your business with simple, reliable tools. We help you manage accounting, payroll, and taxes in the cloud, so your records stay accurate and insights are always ready when you need them.",
            defaultBg: "bg-gradient-to-br from-[#373B44] to-[#2A5298]",
            link: "/accounting-systems"
        },
        {
            id: "ps-4",
            title: "HR & Recruitment Platforms",
            category: "solution",
            desc: "Make hiring and people management easier for your business. From finding the right talent to smooth onboarding and daily HR tasks, our tools help you manage employees better and keep them engaged throughout their journey.",
            defaultBg: "bg-gradient-to-bl from-[#373B44] to-[#141E30]",
            link: "/hr-recruitment"
        },
    ]
},
   techSoftware: {
    id: "tech-software",
    title: "Technology & Software",
    heroImg: "/assets/what/item16.png",
    overviewImg: "/assets/what/item5.png",
    overviewTitle: "Engineering the Future",
    overviewText: "We collaborate with tech companies to build practical SaaS products, reliable cloud systems, and strong cybersecurity, helping them grow confidently while staying secure and scalable.",
    solutions: [
        {
            id: "tech-1",
            title: "SaaS Companies",
            category: "solution",
            desc: "We help you bring your SaaS ideas to life faster with simple, scalable systems. From managing users to handling billing automatically, we build reliable foundations that grow easily with your business and keep everything running smoothly.",
            defaultBg: "bg-gradient-to-b from-[#11998e] to-[#38ef7d]",
            link: "/saas"
        },
        {
            id: "tech-2",
            title: "Software Product Companies",
            category: "solution",
            desc: "Strengthen your team with our dedicated engineers who build custom software and mobile apps from start to finish. We work in short, flexible cycles, carefully test everything, and ensure smooth updates so your product runs reliably and grows with your business.",
            defaultBg: "bg-gradient-to-r from-[#11998e] to-[#00C9FF]",
            link: "/software-products"
        },
        {
            id: "tech-3",
            title: "Cloud Platforms",
            category: "solution",
            desc: "Help your business move to the cloud without stress. We set up smart, automated systems that grow with you, keep things running smoothly, and help you save on infrastructure costs.",
            defaultBg: "bg-gradient-to-br from-[#11998e] to-[#0083B0]",
            link: "/cloud-platforms"
        },
        {
            id: "tech-4",
            title: "Artificial Intelligence Platforms",
            category: "solution",
            desc: "We help businesses work smarter by adding custom AI and machine learning into everyday processes. From understanding data to predicting outcomes and using computer vision, we build solutions that fit naturally into your workflow and make decision-making easier.",
            defaultBg: "bg-gradient-to-bl from-[#11998e] to-[#0F2027]",
            link: "/ai-platforms"
        },
        {
            id: "tech-5",
            title: "Cybersecurity Solutions",
            category: "solution",
            desc: "Keep your business safe with smarter, simpler security. We use zero-trust systems and AI-based monitoring to spot threats early and protect your data, so you can focus on growing without worry.",
            defaultBg: "bg-gradient-to-tr from-[#11998e] to-[#203A43]",
            link: "/cybersecurity"
        },
    ]
},
   automotive: {
    id: "automotive",
    title: "Automotive & Mobility",
    heroImg: "/assets/what/img4.png",
    overviewImg: "/assets/what/item4.png",
    overviewTitle: "Driving Next-Gen Mobility",
    overviewText: "We build smart automotive solutions like connected dashboards and EV charging systems, making everyday driving simpler, smarter, and more connected.",
    solutions: [
        {
            id: "auto-1",
            title: "Automotive OEM Systems",
            category: "solution",
            desc: "Help build the cars of tomorrow with secure embedded software that powers infotainment, real-time diagnostics, and vehicle tracking. We make sure everything works smoothly together so drivers get a simple, smart, and connected experience every time they’re on the road.",
            defaultBg: "bg-gradient-to-b from-[#8E0E00] to-[#1F1C18]",
            link: "/automotive-oem"
        },
        {
            id: "auto-2",
            title: "Electric Vehicle Platforms",
            category: "solution",
            desc: "Help drive the EV shift with simple, smart software for managing batteries and finding charging stations. We also make payments easy, so EV owners can charge smoothly without any hassle.",
            defaultBg: "bg-gradient-to-r from-[#8E0E00] to-[#B31217]",
            link: "/ev-platforms"
        },
        {
            id: "auto-3",
            title: "Connected Vehicles",
            category: "solution",
            desc: "Enable smarter, safer driving with reliable V2X communication. We help vehicles stay connected and updated through secure over-the-air updates, making it easy to add new features and improve performance anytime.",
            defaultBg: "bg-gradient-to-br from-[#8E0E00] to-[#E52D27]",
            link: "/connected-vehicles"
        },
        {
            id: "auto-4",
            title: "Mobility Platforms",
            category: "solution",
            desc: "We help make city travel easier with simple apps for car sharing, rentals, and different transport options. Everything from finding a vehicle to payments and user checks works smoothly in one place.",
            defaultBg: "bg-gradient-to-bl from-[#8E0E00] to-[#430000]",
            link: "/mobility-platforms"
        },
        {
            id: "auto-5",
            title: "Autonomous Driving Systems",
            category: "solution",
            desc: "Help your team move faster in R&D with easy-to-use data labeling tools and realistic 3D simulations. We create safe, reliable systems to train and test self-driving technology with confidence.",
            defaultBg: "bg-gradient-to-tr from-[#8E0E00] to-[#2B0000]",
            link: "/autonomous-driving"
        },
    ]
},
   aerospace: {
    id: "aerospace",
    title: "Aerospace & Defense",
    heroImg: "/assets/what/img5.png",
    overviewImg: "/assets/what/item3.png",
    overviewTitle: "Reaching New Heights",
    overviewText: "We develop secure and highly reliable software for aviation maintenance, satellite tracking, and defense systems, focusing on accuracy, safety, and real-world performance that critical operations can truly depend on.",
    solutions: [
        {
            id: "aero-1",
            title: "Aviation Technology",
            category: "solution",
            desc: "We support aviation teams with simple, reliable software for flight planning, crew scheduling, and secure communication. Our focus is to make operations smoother, reduce fuel use, and help every flight stay safe, efficient, and fully compliant with global standards.",
            defaultBg: "bg-gradient-to-b from-[#4B79A1] to-[#283E51]",
            link: "/aviation-tech"
        },
        {
            id: "aero-2",
            title: "Defense Systems",
            category: "solution",
            desc: "We build secure, reliable systems for defence teams, helping them share information in real time. Our solutions stay strong, safe, and dependable even in the toughest and most critical situations.",
            defaultBg: "bg-gradient-to-r from-[#4B79A1] to-[#1E3C72]",
            link: "/defense-systems"
        },
        {
            id: "aero-3",
            title: "Satellite Systems",
            category: "solution",
            desc: "Make sense of complex space data with tools that are built to be simple and reliable. From imaging to real-time satellite tracking, we help you stay informed, in control, and confident.",
            defaultBg: "bg-gradient-to-br from-[#4B79A1] to-[#2A5298]",
            link: "/satellite-systems"
        },
        {
            id: "aero-4",
            title: "Aviation Maintenance Systems",
            category: "solution",
            desc: "Keep passengers safe and operations stress-free with easy-to-use MRO software. Track parts, stay compliant, and plan maintenance ahead of time, so you can avoid problems and keep everything running smoothly.",
            defaultBg: "bg-gradient-to-bl from-[#4B79A1] to-[#0B141A]",
            link: "/aviation-maintenance"
        },
    ]
},
    utilities: {
    id: "utilities",
    title: "Utilities",
    heroImg: "/assets/what/img6.png",
    overviewImg: "/assets/what/item2.png",
    overviewTitle: "Empowering Essential Services",
    overviewText: "Make public utilities smarter and easier to manage with simple solutions for metering, grid control, and billing across water, electricity, and waste services.",
    solutions: [
        {
            id: "util-1",
            title: "Water Utilities",
            category: "solution",
            desc: "Make water systems smarter and easier to manage with IoT leak detection and real-time quality monitoring. Add simple, transparent billing portals that build trust, encourage saving water, and streamline collections.",
            defaultBg: "bg-gradient-to-b from-[#0052D4] to-[#4364F7]",
            link: "/water-utilities"
        },
        {
            id: "util-2",
            title: "Electricity Utilities",
            category: "solution",
            desc: "Make energy management simpler with smart software that tracks usage, detects outages in real time, and helps people understand and manage their daily electricity consumption more efficiently.",
            defaultBg: "bg-gradient-to-r from-[#0052D4] to-[#6FB1FC]",
            link: "/electricity-utilities"
        },
        {
            id: "util-3",
            title: "Waste Management Systems",
            category: "solution",
            desc: "Make city waste management simpler and more efficient with smart routing and sensor-based bins. Collect waste only when needed, reduce fuel costs, avoid delays, and keep cities cleaner with less effort.",
            defaultBg: "bg-gradient-to-br from-[#0052D4] to-[#1CB5E0]",
            link: "/waste-management"
        },
        {
            id: "util-4",
            title: "Energy Distribution Platforms",
            category: "solution",
            desc: "Keep your power systems running smoothly, even during peak demand. We use smart tools to balance energy and manage assets, ensuring reliable supply from both traditional and renewable sources.",
            defaultBg: "bg-gradient-to-bl from-[#0052D4] to-[#000046]",
            link: "/energy-distribution"
        },
    ]
},
   nonProfit: {
    id: "non-profit",
    title: "Non-Profit & NGOs",
    heroImg: "/assets/what/img7.png",
    overviewImg: "/assets/what/item1.png",
    overviewTitle: "Tech for Social Impact",
    overviewText: "Make your mission stronger with simple, transparent donations, easy volunteer management, and effective fundraising tools.",
    solutions: [
        {
            id: "ngo-1",
            title: "Donation Platforms",
            category: "solution",
            desc: "Make giving easy, secure, and meaningful. Enable smooth multi-currency payments and hassle-free recurring donations, while giving donors clear, simple insights into how their contributions are making a real difference.",
            defaultBg: "bg-gradient-to-b from-[#FF512F] to-[#DD2476]",
            link: "/donation-platforms"
        },
        {
            id: "ngo-2",
            title: "Fundraising Systems",
            category: "solution",
            desc: "Reach more people with simple, flexible crowdfunding tools that make sharing easy. Connect smoothly with your donor systems to build real relationships and keep your fundraising growing over time.",
            defaultBg: "bg-gradient-to-r from-[#FF512F] to-[#F09819]",
            link: "/fundraising"
        },
        {
            id: "ngo-3",
            title: "Volunteer Management Systems",
            category: "solution",
            desc: "Make managing large social initiatives simpler with easy scheduling and clear communication. Keep track of volunteer hours, assign tasks smoothly, and create meaningful reports that truly reflect your impact.",
            defaultBg: "bg-gradient-to-br from-[#FF512F] to-[#CB2D3E]",
            link: "/volunteer-management"
        },
    ]
},
  bfsi: {
    id: "bfsi",
    title: "Banking, Financial Services & Insurance",
    heroImg: "/assets/what/item1.png",
    overviewImg: "/assets/what/img4.png",
    overviewTitle: "Modernizing Financial Experiences",
    overviewText: "At Mobikode, we create secure and reliable FinTech, banking, and insurance solutions that help businesses build trust, stay compliant, and run smoothly while delivering better experiences to their customers.",
    solutions: [
        {
            id: "bfsi-1",
            title: "Retail Banking",
            category: "solution",
            desc: "Make banking simpler and more convenient with secure, easy-to-use digital solutions. Give customers quick access to their accounts, helpful insights, and smooth, hassle-free transactions, so managing money feels effortless and stress-free.",
            defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
            link: "/retail-banking"
        },
        {
            id: "bfsi-2",
            title: "Corporate Banking",
            category: "solution",
            desc: "Make your B2B finances easier to manage with simple, secure corporate portals. Handle cash flow, trade finance, and approvals smoothly, while staying in control and confident with every transaction.",
            defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
            link: "/corporate-banking"
        },
        {
            id: "bfsi-3",
            title: "Investment Banking",
            category: "solution",
            desc: "Support fast-moving financial teams with secure, high-speed trading platforms and reliable data rooms. Help analysts make better decisions with real-time insights and smart portfolio tools built for today’s dynamic markets.",
            defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
            link: "/investment-banking"
        },
        {
            id: "bfsi-4",
            title: "FinTech",
            category: "solution",
            desc: "Make finance simpler and more accessible with modern solutions like lending apps, digital wallets, and neo-banking platforms. We create user-friendly, compliant systems that help you serve people faster and more effectively.",
            defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
            link: "/fintech"
        },
        {
            id: "bfsi-5",
            title: "Insurance (Life, Health, General)",
            category: "solution",
            desc: "Make insurance simpler and faster with smart AI solutions that handle claims and underwriting. Give your customers an easy, transparent experience with mobile tools for quick submissions and real-time updates.",
            defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
            link: "/insurance-tech"
        },
        {
            id: "bfsi-6",
            title: "Wealth Management",
            category: "solution",
            desc: "Help advisors and investors manage their wealth with simple, secure dashboards and personalized guidance. Get clear insights into performance and make smarter decisions with confidence for long-term financial growth.",
            defaultBg: "bg-gradient-to-t from-[#01386A] to-[#243B55]",
            link: "/wealth-management"
        },
        {
            id: "bfsi-7",
            title: "Asset Management",
            category: "solution",
            desc: "Stay in control of your global assets with clear insights and easy-to-use dashboards. Automate compliance and risk checks, so you can protect your investments and make smarter decisions with confidence.",
            defaultBg: "bg-gradient-to-b from-[#01386A] to-[#112240]",
            link: "/asset-management"
        },
        {
            id: "bfsi-8",
            title: "Payment Systems",
            category: "solution",
            desc: "Make global payments simple and stress-free with secure, reliable solutions from gateways to digital wallets and cross-border transfers. We focus on keeping every transaction smooth, safe, and easy for your business and customers.",
            defaultBg: "bg-gradient-to-r from-[#01386A] to-[#34495E]",
            link: "/payment-systems"
        },
        {
            id: "bfsi-9",
            title: "Lending Platforms",
            category: "solution",
            desc: "Make lending simpler and faster with AI-powered credit checks and automated approvals. Reduce risk while giving customers a smooth, stress-free experience from application to final disbursement built on trust and efficiency.",
            defaultBg: "bg-gradient-to-br from-[#01386A] to-[#2C3E50]",
            link: "/lending-platforms"
        },
    ]
},
   manufacturing: {
    id: "manufacturing",
    title: "Manufacturing & Industrial Automation",
    heroImg: "/assets/what/item4.png",
    overviewImg: "/assets/what/img1.png",
    overviewTitle: "Powering Industry 4.0",
    overviewText: "We help manufacturers take a simple step toward becoming smarter factories. With IoT and automation, we reduce downtime, improve daily operations, and make processes smoother, more efficient, and easier to manage.",
    solutions: [
        {
            id: "mfg-1",
            title: "Industrial Manufacturing",
            category: "solution",
            desc: "Make your factory operations smoother with ERP solutions built around your needs. From better planning to easier procurement and resource management, we help you avoid delays and keep production running without disruptions.",
            defaultBg: "bg-gradient-to-b from-[#2C3E50] to-[#4CA1AF]",
            link: "/industrial-manufacturing"
        },
        {
            id: "mfg-2",
            title: "Automotive Manufacturing",
            category: "solution",
            desc: "Make vehicle production smoother with smart, custom software that keeps your assembly lines and supply chain in sync. Track every part easily, maintain quality, and ensure everything runs efficiently from start to finish.",
            defaultBg: "bg-gradient-to-r from-[#2C3E50] to-[#34495E]",
            link: "/auto-manufacturing"
        },
        {
            id: "mfg-3",
            title: "Electronics Manufacturing",
            category: "solution",
            desc: "Keep your production quality high with clear tracking and dependable quality checks. From microchip creation to final packaging, we help you stay consistent, compliant, and confident at every step.",
            defaultBg: "bg-gradient-to-br from-[#2C3E50] to-[#7F8C8D]",
            link: "/electronics-manufacturing"
        },
        {
            id: "mfg-4",
            title: "Aerospace Manufacturing",
            category: "solution",
            desc: "We create secure, easy-to-use software for aerospace manufacturing that helps you track every step of production. It keeps everything accurate, compliant, and reliable—so every part meets the highest safety standards for flight.",
            defaultBg: "bg-gradient-to-bl from-[#2C3E50] to-[#95A5A6]",
            link: "/aerospace-manufacturing"
        },
        {
            id: "mfg-5",
            title: "Heavy Equipment",
            category: "solution",
            desc: "Help your machines run longer and more reliably with smart IoT monitoring and predictive maintenance. We track real-time performance, spot early warning signs, and help you fix issues before they turn into costly breakdowns, so your operations stay smooth and uninterrupted.",
            defaultBg: "bg-gradient-to-tr from-[#2C3E50] to-[#1A252F]",
            link: "/heavy-equipment"
        },
        {
            id: "mfg-6",
            title: "Smart Factory / Industry 4.0",
            category: "solution",
            desc: "Modernize your factory with digital twins and automation that actually make work easier. We help connect old machines to the cloud, improve day-to-day efficiency, and turn real-time data into simple, useful insights for steady, continuous improvement.",
            defaultBg: "bg-gradient-to-t from-[#2C3E50] to-[#2C3E50]",
            link: "/smart-factory"
        },
        {
            id: "mfg-7",
            title: "MES / SCADA Systems",
            category: "solution",
            desc: "Take better control of your production with smart Manufacturing Execution Systems and SCADA solutions. We help you see what’s happening on the shop floor in real time, collect data instantly, and keep machines and systems working together smoothly, so your operations run more efficiently and decisions become easier and faster.",
            defaultBg: "bg-gradient-to-b from-[#2C3E50] to-[#11181F]",
            link: "/mes-scada"
        },
    ]
},
};